import { TEntityRef } from '@ws/shared/types';
import { getDeepCopy } from '@ws/shared/utils';

export function expandArrayWithItemsAtPosition(
  children: TEntityRef[],
  itemsToInsert: TEntityRef[],
  position?: number,
) {
  if (typeof position === 'undefined' || position === -1) {
    return [...children, ...itemsToInsert];
  }

  const newChildren = [
    ...children.slice(0, position),
    ...itemsToInsert,
    ...children.slice(position),
  ];

  return getDeepCopy(newChildren);
}
